// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/blocks/list-widget.scss
// module id = 1067
// module chunks = 62